function getHeight(document: Document): number {
  // stackoverflow.com/questions/1145850/
  const body = document.body;
  const htmlTag = document.documentElement;
  const height = Math.max(
    body.scrollHeight,
    body.offsetHeight,
    htmlTag.clientHeight,
    htmlTag.scrollHeight,
    htmlTag.offsetHeight,
  );

  return height;
}

function setHeight(iFrame: HTMLIFrameElement, iFrameDocument: Document) {
  const documentHeight = getHeight(iFrameDocument);
  const heightCss = `${documentHeight}px`;
  iFrame.style.display = 'none';
  iFrame.style.height = heightCss;
  iFrame.style.display = 'block';
}

export const adjustIframeHeight = (selector: string): void => {
  const iFrame = window.document.querySelector<HTMLIFrameElement>(selector);
  if (!iFrame) {
    throw new Error(`Couldn't find iFrame with selector ${selector}`);
  }

  if (!iFrame.contentWindow) {
    throw new Error(`iFrame with selector ${selector} has no contentWindow`);
  }
  const iFrameDocument = iFrame.contentDocument || iFrame.contentWindow.document;

  // There's a load race condition.
  // The iframe containing the preview could be loaded by the time this
  // function completes, but it also might not.
  // Due to that reason, we are forced to first check the ready state of the
  // document
  if (iFrameDocument.readyState === 'complete') {
    setHeight(iFrame, iFrameDocument);
  } else {
    iFrame.onload = () => {
      setHeight(iFrame, iFrameDocument);
    };
  }
};
